import { render } from "./HeroiconsSolidLockClosed.vue?vue&type=template&id=699669cf"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLockClosed.vue"]])

export default __exports__